<script>
    import ChevronDown from 'lucide-svelte/icons/chevron-down';
    import ChevronUp from 'lucide-svelte/icons/chevron-up';

    export let data;
    data = JSON.parse(data).map((d) => d.table);

    // Array to keep track of which sections (h3 and corresponding text) are expanded
    let expandedSections = [];

    // Group content into sections based on h3 headings
    let sections = [];
    let currentSection = null;

    // Process the data into sections
    data.forEach((item) => {
        if (item.type === 'h2') {
            // Push the previous section if it exists
            if (currentSection) {
                sections.push(currentSection);
            }
            // Add the h2 as its own section without collapsible content
            sections.push({ heading: item, content: [], isH2: true });
            currentSection = null; // Reset currentSection
        } else if (item.type === 'h3') {
            // Push the previous section if it exists
            if (currentSection) {
                sections.push(currentSection);
            }
            currentSection = { heading: item, content: [], isH2: false };
        } else if (currentSection) {
            // Add content to the current section
            currentSection.content.push(item);
        }
    });

    // Add the last section
    if (currentSection) {
        sections.push(currentSection);
    }

    // Initialize expandedSections based on the number of sections, setting the first section expanded by default
    expandedSections = sections.map((section, index) => index === 1);

    // Function to toggle the expanded state for a section
    const toggleSection = (index) => {
        expandedSections = expandedSections.map((expanded, i) => (i === index ? !expanded : expanded));
    };
</script>

<div class="home-middle">
    {#each sections as section, index}
        <!-- Render the h2 heading directly -->
        {#if section.isH2}
            <h2 class="about-header-h2">{section.heading.value}</h2>
        {:else}
            <!-- Render the h3 heading and set up the toggle -->
            <h3
                class="about-header-h3 {expandedSections[index] ? 'expanded' : ''}"
                on:click={() => toggleSection(index)}
            >
                {section.heading.value}

                {#if expandedSections[index]}
                    <ChevronUp size={32} />
                {:else}
                    <ChevronDown size={32} />
                {/if}
            </h3>

            <!-- Render the section content if the section is expanded -->
            {#if expandedSections[index]}
                {#each section.content as item}
                    <p class="body-copy">
                        {@html item.value}
                    </p>
                {/each}
            {/if}
        {/if}
    {/each}
</div>

<style lang="scss">
    .body-copy {
        margin: 1em 0;
        line-height: var(--scale1);
    }

    .about-header {
        &-h2 {
            font-size: var(--scale1) !important;
            font-weight: bold;
        }

        &-h3 {
            display: flex;
            justify-content: space-between;
            margin: var(--spacing0) 0;
            font-size: var(--scale0) !important;
            font-weight: 500;

            &:hover {
                background-color: var(--gray-3);
                cursor: pointer;
                text-decoration: underline;
            }
        }
    }

    .home-middle {
        &::after {
            display: block;
            width: 100%;
            height: 1px;
            margin: var(--spacing2) 0;
            background-color: var(--color-text-body);
            content: '';
        }
    }
</style>
